var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRdashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "96px",
    viewBox: "0 0 132 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.316,15.7714286 L84.316,66.5632653 C84.316,67.844898 83.2896,68.8897959 81.9472,68.8897959 L2.3688,68.8897959 C1.0264,68.8897959 0,67.844898 0,66.5632653 L0,15.7714286 C0,14.4897959 1.0264,13.4367347 2.3688,13.4367347 L81.9472,13.4367347 C83.2896,13.4367347 84.316,14.4897959 84.316,15.7714286 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.4%",
    y: "-40.6%",
    width: "174.7%",
    height: "213.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.433058908%",
    y1: "44.0677966%",
    x2: "100.220658%",
    y2: "44.0677966%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.152001351%",
    y1: "50.5%",
    x2: "99.7128863%",
    y2: "50.5%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.7632,41.2897959 L96,60.3591837 C96,61.0040816 95.4472,61.5673469 94.816,61.5673469 L76.5792,61.5673469 C75.9472,61.5673469 75.3944,61.0040816 75.3944,60.3591837 L75.3944,35.8938776 C75.3944,35.2489796 75.9472,34.6857143 76.5792,34.6857143 L89.8424,34.6857143 L95.7632,41.2897959 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-152.9%",
    y: "-83.7%",
    width: "405.7%",
    height: "334.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00684697022%",
    y1: "50.1269036%",
    x2: "99.4453954%",
    y2: "50.1269036%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.2474147%",
    y1: "31.3521108%",
    x2: "78.8732829%",
    y2: "69.3742489%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3944,26.0734694 L46.3424,26.0734694 C45.4736,26.0734694 44.8424,25.355102 44.8424,24.5469388 L44.8424,5.95918367 C44.8424,5.06938776 45.5528,4.4244898 46.3424,4.4244898 L75.3944,4.4244898 C76.2632,4.4244898 76.8944,5.15102041 76.8944,5.95918367 L76.8944,24.5469388 C76.8944,25.4367347 76.184,26.0734694 75.3944,26.0734694 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.3%",
    y: "-32.3%",
    width: "168.6%",
    height: "201.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.294117647   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resellers",
    transform: "translate(-252.000000, -869.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 32,
    transform: "translate(270.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2368,80 C63.9064,80 81.4736,62.0897959 81.4736,40 C81.4736,17.9102041 63.9064,0 42.2368,0 C20.5672,0 3,17.9102041 3,40 C3,62.0897959 20.5672,80 42.2368,80 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.316,64.6285714 L26.6056,64.6285714 C25.2632,64.6285714 24.1576,63.5020408 24.1576,62.1306122 L24.1576,23.2571429 C24.1576,21.8938776 25.2632,20.7673469 26.6056,20.7673469 L78.316,20.7673469 C79.6576,20.7673469 80.7632,21.8938776 80.7632,23.2571429 L80.7632,62.2122449 C80.684,63.5836735 79.6576,64.6285714 78.316,64.6285714 Z",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0264,18.1877551 C4.5928,18.1877551 5.0528,17.722449 5.0528,17.1428571 C5.0528,16.5632653 4.5928,16.0979592 4.0264,16.0979592 C3.4592,16.0979592 3,16.5632653 3,17.1428571 C3,17.722449 3.4592,18.1877551 4.0264,18.1877551 Z",
    id: "Path",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9472,18.1877551 C7.5144,18.1877551 7.9736,17.722449 7.9736,17.1428571 C7.9736,16.5632653 7.5144,16.0979592 6.9472,16.0979592 C6.3808,16.0979592 5.9208,16.5632653 5.9208,17.1428571 C5.9208,17.722449 6.3808,18.1877551 6.9472,18.1877551 Z",
    id: "Path",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9472,18.1877551 C10.5144,18.1877551 10.9736,17.722449 10.9736,17.1428571 C10.9736,16.5632653 10.5144,16.0979592 9.9472,16.0979592 C9.3808,16.0979592 8.9208,16.5632653 8.9208,17.1428571 C8.9208,17.722449 9.3808,18.1877551 9.9472,18.1877551 Z",
    id: "Path",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1576,26.6367347 L29.684,26.6367347 C29.3688,26.6367347 29.2104,26.4 29.2104,26.155102 C29.2104,25.8367347 29.4472,25.6734694 29.684,25.6734694 L57.1576,25.6734694 C57.4736,25.6734694 57.6312,25.9183673 57.6312,26.155102 C57.7104,26.4 57.4736,26.6367347 57.1576,26.6367347 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1576,29.5346939 L29.684,29.5346939 C29.3688,29.5346939 29.2104,29.2979592 29.2104,29.0530612 C29.2104,28.7346939 29.4472,28.5714286 29.684,28.5714286 L57.1576,28.5714286 C57.4736,28.5714286 57.6312,28.8163265 57.6312,29.0530612 C57.7104,29.2979592 57.4736,29.5346939 57.1576,29.5346939 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,32.677551 L29.684,32.677551 C29.3688,32.677551 29.2104,32.4326531 29.2104,32.1959184 C29.2104,31.8693878 29.4472,31.7142857 29.684,31.7142857 L43.5,31.7142857 C43.816,31.7142857 43.9736,31.9510204 43.9736,32.1959184 C44.0528,32.4326531 43.816,32.677551 43.5,32.677551 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7368,65.355102 L4.7368,65.355102 C3.7896,65.355102 3.0792,64.6285714 3.0792,63.6653061 L3.0792,22.2938776 C3.0792,21.3306122 3.7896,20.6040816 4.7368,20.6040816 L19.7368,20.6040816 C20.684,20.6040816 21.3944,21.3306122 21.3944,22.2938776 L21.3944,63.5836735 C21.3944,64.5469388 20.684,65.355102 19.7368,65.355102 Z",
    id: "Path",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2368,26.3183673 C13.24,26.3183673 14.0528,25.4857143 14.0528,24.4653061 C14.0528,23.444898 13.24,22.6122449 12.2368,22.6122449 C11.2344,22.6122449 10.4208,23.444898 10.4208,24.4653061 C10.4208,25.4857143 11.2344,26.3183673 12.2368,26.3183673 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0792,28.5714286 L6.4736,28.5714286 C6.316,28.5714286 6.1576,28.4081633 6.1576,28.2530612 C6.1576,28.0897959 6.316,27.9265306 6.4736,27.9265306 L18,27.9265306 C18.1576,27.9265306 18.316,28.0897959 18.316,28.2530612 C18.3944,28.4081633 18.2368,28.5714286 18.0792,28.5714286 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0792,30.9877551 L6.4736,30.9877551 C6.316,30.9877551 6.1576,30.8244898 6.1576,30.6612245 C6.1576,30.5061224 6.316,30.3428571 6.4736,30.3428571 L18,30.3428571 C18.1576,30.3428571 18.316,30.5061224 18.316,30.6612245 C18.3944,30.8244898 18.2368,30.9877551 18.0792,30.9877551 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0792,35.2489796 L6.4736,35.2489796 C6.316,35.2489796 6.1576,35.0938776 6.1576,34.9306122 C6.1576,34.7673469 6.316,34.6040816 6.4736,34.6040816 L18,34.6040816 C18.1576,34.6040816 18.316,34.7673469 18.316,34.9306122 C18.3944,35.0938776 18.2368,35.2489796 18.0792,35.2489796 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6576,37.7469388 L6.3944,37.7469388 C6.316,37.7469388 6.1576,37.6653061 6.1576,37.5020408 L6.1576,37.2653061 C6.1576,37.1836735 6.2368,37.0204082 6.3944,37.0204082 L10.6576,37.0204082 C10.7368,37.0204082 10.8944,37.1020408 10.8944,37.2653061 L10.8944,37.5020408 C10.8944,37.6653061 10.816,37.7469388 10.6576,37.7469388 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0792,42.2530612 L6.4736,42.2530612 C6.316,42.2530612 6.1576,42.0897959 6.1576,41.9346939 C6.1576,41.7714286 6.316,41.6081633 6.4736,41.6081633 L18,41.6081633 C18.1576,41.6081633 18.316,41.7714286 18.316,41.9346939 C18.3944,42.0897959 18.2368,42.2530612 18.0792,42.2530612 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6576,44.7510204 L6.3944,44.7510204 C6.316,44.7510204 6.1576,44.6693878 6.1576,44.5061224 L6.1576,44.2693878 C6.1576,44.1877551 6.2368,44.0244898 6.3944,44.0244898 L10.6576,44.0244898 C10.7368,44.0244898 10.8944,44.1061224 10.8944,44.2693878 L10.8944,44.5061224 C10.8944,44.5877551 10.816,44.7510204 10.6576,44.7510204 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0792,49.1755102 L6.4736,49.1755102 C6.316,49.1755102 6.1576,49.0122449 6.1576,48.8571429 C6.1576,48.6938776 6.316,48.5306122 6.4736,48.5306122 L18,48.5306122 C18.1576,48.5306122 18.316,48.6938776 18.316,48.8571429 C18.3944,49.0122449 18.2368,49.1755102 18.0792,49.1755102 Z",
    id: "Path",
    fill: "#2D5887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6576,51.6734694 L6.3944,51.6734694 C6.316,51.6734694 6.1576,51.5918367 6.1576,51.4285714 L6.1576,51.1836735 C6.1576,51.1102041 6.2368,50.9469388 6.3944,50.9469388 L10.6576,50.9469388 C10.7368,50.9469388 10.8944,51.0285714 10.8944,51.1836735 L10.8944,51.4285714 C10.8944,51.5918367 10.816,51.6734694 10.6576,51.6734694 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.316,57.7877551 L83.684,57.7877551 C83.5264,57.7877551 83.4472,57.6244898 83.4472,57.5428571 C83.4472,57.3877551 83.6056,57.3061224 83.684,57.3061224 L84.316,57.3061224 C84.4736,57.3061224 84.5528,57.4612245 84.5528,57.5428571 C84.6312,57.6244898 84.4736,57.7877551 84.316,57.7877551 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,57.7877551 L78.6312,57.7877551 C78.4736,57.7877551 78.3944,57.6244898 78.3944,57.5428571 C78.3944,57.3877551 78.5528,57.3061224 78.6312,57.3061224 L82.5,57.3061224 C82.6576,57.3061224 82.7368,57.4612245 82.7368,57.5428571 C82.7368,57.6244898 82.6576,57.7877551 82.5,57.7877551 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5528,38.7102041 L78.7896,38.7102041 C78.5528,38.7102041 78.3944,38.555102 78.3944,38.3102041 C78.3944,38.0653061 78.5528,37.9102041 78.7896,37.9102041 L87.5528,37.9102041 C87.7896,37.9102041 87.9472,38.0653061 87.9472,38.3102041 C87.8688,38.555102 87.7104,38.7102041 87.5528,38.7102041 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1056,40.8081633 L78.7896,40.8081633 C78.5528,40.8081633 78.3944,40.644898 78.3944,40.4 C78.3944,40.1632653 78.5528,40 78.7896,40 L82.1056,40 C82.3424,40 82.5,40.1632653 82.5,40.4 C82.5,40.644898 82.3424,40.8081633 82.1056,40.8081633 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8424,34.6857143 L89.8424,39.9183673 C89.8424,40.644898 90.4736,41.2897959 91.184,41.2897959 L95.7632,41.2897959",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8424,44.8326531 L88.2632,44.8326531 L83.5264,44.8326531 L79.1056,44.8326531 C78.632,44.8326531 78.2368,45.2326531 78.2368,45.7142857 L78.2368,53.844898 C78.2368,54.3265306 78.632,54.7265306 79.1056,54.7265306 L92.8424,54.7265306 C93.316,54.7265306 93.7104,54.3265306 93.7104,53.844898 L93.7104,45.7959184 C93.7896,45.2326531 93.3944,44.8326531 92.8424,44.8326531 Z M83.8424,51.9918367 L83.8424,50.1387755 L88.0264,50.1387755 L88.0264,51.9918367 L83.8424,51.9918367 Z M88.0264,52.555102 L88.0264,54.244898 L83.8424,54.244898 L83.8424,52.555102 L88.0264,52.555102 Z M88.0264,47.8040816 L88.0264,49.6571429 L83.8424,49.6571429 L83.8424,47.8040816 L88.0264,47.8040816 Z M83.8424,47.2408163 L83.8424,45.3959184 L88.0264,45.3959184 L88.0264,47.2408163 L83.8424,47.2408163 Z M93.2368,49.6571429 L88.5792,49.6571429 L88.5792,47.8040816 L93.2368,47.8040816 L93.2368,49.6571429 Z M83.2896,49.6571429 L78.7896,49.6571429 L78.7896,47.8040816 L83.2896,47.8040816 L83.2896,49.6571429 Z M78.7896,50.2204082 L83.2896,50.2204082 L83.2896,52.0734694 L78.7896,52.0734694 L78.7896,50.2204082 Z M88.5792,50.2204082 L93.2368,50.2204082 L93.2368,52.0734694 L88.5792,52.0734694 L88.5792,50.2204082 Z M93.2368,45.7959184 L93.2368,47.322449 L88.5792,47.322449 L88.5792,45.4693878 L92.8424,45.4693878 C93.0792,45.3959184 93.2368,45.5510204 93.2368,45.7959184 Z M79.1056,45.3959184 L83.2896,45.3959184 L83.2896,47.2408163 L78.7896,47.2408163 L78.7896,45.7142857 C78.7896,45.5510204 78.9472,45.3959184 79.1056,45.3959184 Z M78.7896,53.844898 L78.7896,52.555102 L83.2896,52.555102 L83.2896,54.244898 L79.1056,54.244898 C78.9472,54.244898 78.7896,54.0816327 78.7896,53.844898 Z M92.8424,54.244898 L88.5792,54.244898 L88.5792,52.555102 L93.2368,52.555102 L93.2368,53.844898 C93.2368,54.0816327 93.0792,54.244898 92.8424,54.244898 Z",
    id: "Shape",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,50.2204082 L71.2104,50.2204082 C70.7368,50.2204082 70.2632,49.8204082 70.2632,49.2571429 L70.2632,44.7510204 C70.2632,44.2693878 70.6576,43.7795918 71.2104,43.7795918 L81,43.7795918 C81.4736,43.7795918 81.9472,44.1877551 81.9472,44.7510204 L81.9472,49.2571429 C81.9472,49.8204082 81.4736,50.2204082 81,50.2204082 Z",
    id: "Path",
    fill: "#1C3754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8424,41.2081633 L39.0792,60.3591837 C39.0792,61.0040816 38.5264,61.5673469 37.8944,61.5673469 L19.6576,61.5673469 C19.0264,61.5673469 18.4736,61.0040816 18.4736,60.3591837 L18.4736,35.7306122 C18.4736,35.0938776 19.0264,34.5306122 19.6576,34.5306122 L32.9208,34.5306122 L38.8424,41.2081633 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.684,54.4081633 L24.7104,54.4081633 C24.5528,54.4081633 24.4736,54.244898 24.4736,54.1632653 C24.4736,54 24.6312,53.9265306 24.7104,53.9265306 L35.684,53.9265306 C35.8424,53.9265306 35.9208,54.0816327 35.9208,54.1632653 C35.9208,54.244898 35.8424,54.4081633 35.684,54.4081633 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3688,54.4081633 L21.4736,54.4081633 C21.316,54.4081633 21.2368,54.244898 21.2368,54.1632653 C21.2368,54 21.3944,53.9265306 21.4736,53.9265306 L23.3688,53.9265306 C23.5264,53.9265306 23.6056,54.0816327 23.6056,54.1632653 C23.6056,54.244898 23.5264,54.4081633 23.3688,54.4081633 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6056,51.4285714 L30.7104,51.4285714 C30.5528,51.4285714 30.4736,51.2653061 30.4736,51.1836735 C30.4736,51.1102041 30.632,50.9469388 30.7104,50.9469388 L35.6056,50.9469388 C35.7632,50.9469388 35.8424,51.1102041 35.8424,51.1836735 C35.8424,51.2653061 35.7632,51.4285714 35.6056,51.4285714 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6576,51.4285714 L21.4736,51.4285714 C21.316,51.4285714 21.2368,51.2653061 21.2368,51.1836735 C21.2368,51.1102041 21.3944,50.9469388 21.4736,50.9469388 L28.6576,50.9469388 C28.816,50.9469388 28.8944,51.1102041 28.8944,51.1836735 C28.8944,51.2653061 28.816,51.4285714 28.6576,51.4285714 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7632,48.3673469 L33.8688,48.3673469 C33.7104,48.3673469 33.6312,48.2122449 33.6312,48.1306122 C33.6312,48.0489796 33.7896,47.8857143 33.8688,47.8857143 L35.7632,47.8857143 C35.9208,47.8857143 36,48.0489796 36,48.1306122 C36,48.2122449 35.9208,48.3673469 35.7632,48.3673469 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0528,48.3673469 L21.632,48.3673469 C21.4736,48.3673469 21.3944,48.2122449 21.3944,48.1306122 C21.3944,48.0489796 21.5528,47.8857143 21.632,47.8857143 L32.0528,47.8857143 C32.2104,47.8857143 32.2896,48.0489796 32.2896,48.1306122 C32.2896,48.2122449 32.2104,48.3673469 32.0528,48.3673469 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3944,57.7061224 L26.684,57.7061224 C26.5264,57.7061224 26.4472,57.5428571 26.4472,57.4612245 C26.4472,57.3061224 26.6056,57.2244898 26.684,57.2244898 L27.316,57.2244898 C27.4736,57.2244898 27.5528,57.3877551 27.5528,57.4612245 C27.6312,57.5428571 27.5528,57.7061224 27.3944,57.7061224 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,57.7061224 L21.632,57.7061224 C21.4736,57.7061224 21.3944,57.5428571 21.3944,57.4612245 C21.3944,57.3061224 21.5528,57.2244898 21.632,57.2244898 L25.5,57.2244898 C25.6576,57.2244898 25.7368,57.3877551 25.7368,57.4612245 C25.816,57.5428571 25.6576,57.7061224 25.5,57.7061224 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8424,45.3959184 L29.0528,45.3959184 C28.8944,45.3959184 28.816,45.2326531 28.816,45.1510204 C28.816,45.0693878 28.9736,44.9061224 29.0528,44.9061224 L35.7632,44.9061224 C35.9208,44.9061224 36,45.0693878 36,45.1510204 C36,45.2326531 36,45.3959184 35.8424,45.3959184 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9208,45.3959184 L21.7104,45.3959184 C21.5528,45.3959184 21.4736,45.2326531 21.4736,45.1510204 C21.4736,45.0693878 21.6312,44.9061224 21.7104,44.9061224 L26.9208,44.9061224 C27.0792,44.9061224 27.1576,45.0693878 27.1576,45.1510204 C27.1576,45.2326531 27.0792,45.3959184 26.9208,45.3959184 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5528,38.555102 L21.7896,38.555102 C21.5528,38.555102 21.3944,38.3918367 21.3944,38.1469388 C21.3944,37.9102041 21.5528,37.7469388 21.7896,37.7469388 L30.5528,37.7469388 C30.7896,37.7469388 30.9472,37.9102041 30.9472,38.1469388 C30.9472,38.3918367 30.7896,38.555102 30.5528,38.555102 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.184,40.7265306 L21.8688,40.7265306 C21.6312,40.7265306 21.4736,40.5632653 21.4736,40.3183673 C21.4736,40.0816327 21.6312,39.9183673 21.8688,39.9183673 L25.184,39.9183673 C25.4208,39.9183673 25.5792,40.0816327 25.5792,40.3183673 C25.5,40.5632653 25.3424,40.7265306 25.184,40.7265306 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8424,34.5306122 L32.8424,39.8367347 C32.8424,40.5632653 33.4736,41.2081633 34.184,41.2081633 L38.7632,41.2081633",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0792,50.1387755 L14.2896,50.1387755 C13.816,50.1387755 13.3424,49.7387755 13.3424,49.1755102 L13.3424,44.6693878 C13.3424,44.1877551 13.7368,43.7061224 14.2896,43.7061224 L24.0792,43.7061224 C24.5528,43.7061224 25.0264,44.1061224 25.0264,44.6693878 L25.0264,49.1755102 C24.9472,49.7387755 24.5528,50.1387755 24.0792,50.1387755 Z",
    id: "Path",
    fill: "#F04B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.184,41.2081633 L67.4208,60.3591837 C67.4208,61.0040816 66.8688,61.5673469 66.2368,61.5673469 L48,61.5673469 C47.3688,61.5673469 46.816,61.0040816 46.816,60.3591837 L46.816,35.7306122 C46.816,35.0938776 47.3688,34.5306122 48,34.5306122 L61.2632,34.5306122 L67.184,41.2081633 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0264,54.4081633 L53.0528,54.4081633 C52.8944,54.4081633 52.816,54.244898 52.816,54.1632653 C52.816,54 52.9736,53.9265306 53.0528,53.9265306 L64.0264,53.9265306 C64.184,53.9265306 64.2632,54.0816327 64.2632,54.1632653 C64.2632,54.244898 64.184,54.4081633 64.0264,54.4081633 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7104,54.4081633 L49.816,54.4081633 C49.6576,54.4081633 49.5792,54.244898 49.5792,54.1632653 C49.5792,54 49.7368,53.9265306 49.816,53.9265306 L51.7104,53.9265306 C51.8688,53.9265306 51.9472,54.0816327 51.9472,54.1632653 C51.9472,54.244898 51.8688,54.4081633 51.7104,54.4081633 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9472,51.3469388 L59.0528,51.3469388 C58.8944,51.3469388 58.816,51.1836735 58.816,51.1102041 C58.816,50.9469388 58.9736,50.8653061 59.0528,50.8653061 L63.9472,50.8653061 C64.1056,50.8653061 64.184,51.0285714 64.184,51.1102041 C64.2632,51.2653061 64.1056,51.3469388 63.9472,51.3469388 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,51.3469388 L49.8944,51.3469388 C49.7368,51.3469388 49.6576,51.1836735 49.6576,51.1102041 C49.6576,50.9469388 49.816,50.8653061 49.8944,50.8653061 L57,50.8653061 C57.1576,50.8653061 57.2368,51.0285714 57.2368,51.1102041 C57.316,51.2653061 57.1576,51.3469388 57,51.3469388 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0264,48.3673469 L62.1312,48.3673469 C61.9736,48.3673469 61.8944,48.2122449 61.8944,48.1306122 C61.8944,48.0489796 62.0528,47.8857143 62.1312,47.8857143 L64.0264,47.8857143 C64.184,47.8857143 64.2632,48.0489796 64.2632,48.1306122 C64.2632,48.2122449 64.184,48.3673469 64.0264,48.3673469 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3944,48.3673469 L49.9736,48.3673469 C49.816,48.3673469 49.7368,48.2122449 49.7368,48.1306122 C49.7368,48.0489796 49.8944,47.8857143 49.9736,47.8857143 L60.3944,47.8857143 C60.5528,47.8857143 60.6312,48.0489796 60.6312,48.1306122 C60.6312,48.2122449 60.5528,48.3673469 60.3944,48.3673469 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7368,57.7061224 L55.1056,57.7061224 C54.9472,57.7061224 54.8688,57.5428571 54.8688,57.4612245 C54.8688,57.3877551 55.0264,57.2244898 55.1056,57.2244898 L55.7368,57.2244898 C55.8944,57.2244898 55.9736,57.3877551 55.9736,57.4612245 C55.9736,57.5428571 55.8944,57.7061224 55.7368,57.7061224 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8424,57.7061224 L49.9736,57.7061224 C49.816,57.7061224 49.7368,57.5428571 49.7368,57.4612245 C49.7368,57.3877551 49.8944,57.2244898 49.9736,57.2244898 L53.8424,57.2244898 C54,57.2244898 54.0792,57.3877551 54.0792,57.4612245 C54.0792,57.5428571 54,57.7061224 53.8424,57.7061224 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.184,45.3959184 L57.4736,45.3959184 C57.316,45.3959184 57.2368,45.2326531 57.2368,45.1510204 C57.2368,45.0693878 57.3944,44.9061224 57.4736,44.9061224 L64.184,44.9061224 C64.3424,44.9061224 64.4208,45.0693878 64.4208,45.1510204 C64.4208,45.2326531 64.3424,45.3959184 64.184,45.3959184 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2632,45.3959184 L50.0528,45.3959184 C49.8944,45.3959184 49.816,45.2326531 49.816,45.1510204 C49.816,45.0693878 49.9736,44.9061224 50.0528,44.9061224 L55.2632,44.9061224 C55.4208,44.9061224 55.5,45.0693878 55.5,45.1510204 C55.5,45.2326531 55.4208,45.3959184 55.2632,45.3959184 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8944,38.555102 L50.1312,38.555102 C49.8944,38.555102 49.7368,38.3918367 49.7368,38.1469388 C49.7368,37.9102041 49.8944,37.7469388 50.1312,37.7469388 L58.8944,37.7469388 C59.1312,37.7469388 59.2896,37.9102041 59.2896,38.1469388 C59.2896,38.3918367 59.1312,38.555102 58.8944,38.555102 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5264,40.7265306 L50.2104,40.7265306 C49.9736,40.7265306 49.816,40.5632653 49.816,40.3183673 C49.816,40.0816327 49.9736,39.9183673 50.2104,39.9183673 L53.5264,39.9183673 C53.7632,39.9183673 53.9208,40.0816327 53.9208,40.3183673 C53.8424,40.5632653 53.684,40.7265306 53.5264,40.7265306 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.184,34.5306122 L61.184,39.8367347 C61.184,40.5632653 61.816,41.2081633 62.5264,41.2081633 L67.1056,41.2081633",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4208,50.1387755 L42.6312,50.1387755 C42.1576,50.1387755 41.684,49.7387755 41.684,49.1755102 L41.684,44.6693878 C41.684,44.1877551 42.0792,43.7061224 42.6312,43.7061224 L52.4208,43.7061224 C52.8944,43.7061224 53.368,44.1061224 53.368,44.6693878 L53.368,49.1755102 C53.2896,49.7387755 52.8944,50.1387755 52.4208,50.1387755 Z",
    id: "Path",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.8688,14.3265306 C62.656,14.3265306 64.1056,12.8489796 64.1056,11.0285714 C64.1056,9.2 62.656,7.72244898 60.8688,7.72244898 C59.0808,7.72244898 57.6312,9.2 57.6312,11.0285714 C57.6312,12.8489796 59.0808,14.3265306 60.8688,14.3265306 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0528,18.1877551 L50.7632,18.1877551 C50.4472,18.1877551 50.2104,17.9510204 50.2104,17.6244898 C50.2104,17.3061224 50.4472,17.0612245 50.7632,17.0612245 L70.9736,17.0612245 C71.2896,17.0612245 71.5264,17.3061224 71.5264,17.6244898 C71.6056,17.9510204 71.368,18.1877551 71.0528,18.1877551 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0528,22.5387755 L50.7632,22.5387755 C50.4472,22.5387755 50.2104,22.2938776 50.2104,21.9755102 C50.2104,21.6489796 50.4472,21.4122449 50.7632,21.4122449 L70.9736,21.4122449 C71.2896,21.4122449 71.5264,21.6489796 71.5264,21.9755102 C71.6056,22.2938776 71.368,22.5387755 71.0528,22.5387755 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdashboard);
export default __webpack_public_path__ + "static/media/rdashboard.343521589e287d7aa37f94cfc224ee30.svg";
export { ForwardRef as ReactComponent };